// src/auth/rbac.js
export const toKey = (resource, action) =>
  `${String(resource || "").toLowerCase()}:${String(action || "").toLowerCase()}`;

// Build a fast lookup Set from [{resource, action}]
export const buildPermSet = (permsArr = []) => {
  const set = new Set();
  permsArr.forEach(p => {
    if (!p) return;
    set.add(toKey(p.resource, p.action));
  });
  return set;
};

// Wildcard-aware check:
// true if user has:
// - all:all
// - resource:all
// - all:action
// - resource:action
export const canDo = (permSet, resource, action) => {
  const r = String(resource).toLowerCase();
  const a = String(action).toLowerCase();
  return (
    permSet.has("all:all") ||
    permSet.has(toKey(r, "all")) ||
    permSet.has(toKey("all", a)) ||
    permSet.has(toKey(r, a))
  );
};

// Convenience
export const canAll = (permSet, list) => list.every(p => canDo(permSet, p.resource, p.action));
export const canAny = (permSet, list) => list.some(p => canDo(permSet, p.resource, p.action));
